import { Component, Inject, OnInit, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { ThemeService } from '../../../shared/theme-service/theme.service';

@Component({
	selector: 'app-pix-help',
	templateUrl: './help.component.html',
	styleUrls: ['./help.component.styl'],
})
export class PixHelpComponent implements OnInit {

	phoneCrCapital = '4004 3500';
	phoneCrMore = '0800 701 3500';
	phoneSAC = '0800 727 0885';

	constructor(
		public dialogRef: MatDialogRef<PixHelpComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private themeService: ThemeService
	) {}

	ngOnInit(): void {
		this.definePhonesByTheme();
	}

	definePhonesByTheme() {
		switch (this.themeService.currentURL) {
			case 'www.powerclub.com.br':
				this.phoneCrCapital = '4003 0583';
				this.phoneCrMore = '0800 770 6301';
				this.phoneSAC = '0800 770 6302';
				break;
		}
	}

	onClose(): void {
		this.dialogRef.close();
	}

	onConfirm(): void {
		this.dialogRef.close(true);
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/help/help.component.ts